import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * A badge to display notifcations to a user.
 */
export const Badge = ({ count, dataId, maxCount = 99, style }) => {
    const displayCount = count > maxCount ? `${maxCount}+` : count;
    return (_jsx(Box, Object.assign({ "data-id": dataId, sx: Object.assign({ backgroundColor: HelixPalette.pink60, borderRadius: '2rem', display: 'flex', justifyContent: 'center', minWidth: '1.125rem', padding: '0 0.125rem', pointerEvents: 'none', width: 'fit-content' }, style) }, { children: _jsx(Typography, Object.assign({}, HelixStyles.style_05, { "data-id": `${dataId}-label`, sx: { color: HelixPalette.white } }, { children: displayCount })) })));
};
